import { Icon } from "./Icon.tsx";

/** "Add Conduit" tool icon — two nodes joined by a pipe. */
export function AddConduitIcon() {
  return (
    <Icon>
      <circle cx="5" cy="19" r="2.5" />
      <circle cx="19" cy="5" r="2.5" />
      <path d="M7 17.5L17 6.5" />
    </Icon>
  );
}
